import Vue from 'vue'
import { ClientTable } from 'vue-tables-2'

Vue.use(ClientTable, {}, false, 'bootstrap4')
